<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>运营商价格档案</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 运营商价格档案 strat -->
      <el-tab-pane name="first" label="运营商价格档案">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.jiagetype" placeholder="请选择" class="select">
              <el-option label="请选择首次/次次" value="-1"></el-option>
              <el-option label="首次" value="1"></el-option>
              <el-option label="次次" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.status" placeholder="请选择" class="select">
              <el-option label="请选择审核状态" value="-1"></el-option>
              <el-option label="出纳已录入" value="1"></el-option>
              <el-option label="总账已审核" value="2"></el-option>
              <el-option label="总经理已审核" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择产品" class="select2">
              <el-option label="请选择产品名称" value=""></el-option>
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Productname" label="产品名称" min-width="13%"></el-table-column>
          <el-table-column prop="Jigouname" label="机构名称" min-width="15%"></el-table-column>
          <el-table-column prop="Jiagetypes" label="首次/次次" min-width="7%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Jiagetype == 1" type="danger">首次</el-button>
              <el-button v-if="scope.row.Jiagetype == 2" type="primary" plain>次次</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Statuss" label="审核状态" min-width="10%"></el-table-column>
          <el-table-column prop="Minnum" label="最小数量" min-width="10%"></el-table-column>
          <el-table-column prop="Maxnum" label="最大数量" min-width="10%"></el-table-column>
          <el-table-column prop="Money" label="单价" min-width="10%"></el-table-column>
          <el-table-column prop="Effectivedate" label="生效时间" min-width="15%"></el-table-column>
          <el-table-column prop="Operation" min-width="10%" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 1" @click="clickedit(scope.$index,scope.row)">编辑</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdelete(scope.$index,scope.row)">删除</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 1 && SubRule_ProductMoney_ZongZhang" @click="clickShenHe(2,scope.row)">总账审核</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.Status == 2 && SubRule_ProductMoney_ZongJingLi" @click="clickShenHe(3,scope.row)">总经理审核</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>

        <!-- 编辑运营商价格档案弹出框 start -->
        <el-dialog title="编辑运营商价格档案" :visible.sync="editdialog" width="30%" :close-on-click-modal="false">
          <el-form :model="editForm" ref="editFormRef" label-width="80px">
            <el-form-item label="所属机构" class="addAdminForm">
              <Rsljigou :propsjigouid="editForm.jigouid" :propsjigouname="editForm.jigouname" @change="changeRsljigouedit"></Rsljigou>
            </el-form-item>
            <el-form-item label="产品名称" class="addAdminForm">
                <el-select v-model="editForm.bomsn" placeholder="请选择产品" class="select2">
                  <el-option
                    v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="首次/次次" class="addAdminForm">
              <el-select v-model="editForm.jiagetype" placeholder="请选择" class="select2">
                <el-option label="首次" value="1"></el-option>
                <el-option label="次次" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="最小数量" class="addAdminForm">
              <el-input v-model="editForm.minnum" placeholder="请输入最小数量"></el-input>
            </el-form-item>
            <el-form-item label="最大数量" class="addAdminForm">
              <el-input v-model="editForm.maxnum" placeholder="请输入最大数量"></el-input>
            </el-form-item>
            <el-form-item label="单价" class="addAdminForm">
              <el-input v-model="editForm.money" placeholder="请输入单价"></el-input>
            </el-form-item>
            <el-form-item label="生效时间" class="addAdminForm">
              <el-date-picker v-model="editForm.effectivedate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="funsaveedit">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 编辑运营商价格档案弹出框 end -->
      </el-tab-pane>
      <!-- 运营商价格档案 end -->

      <!-- 添加运营商价格档案 start -->
      <el-tab-pane name="second" label="添加运营商价格档案">
        <el-form :model="addForm" ref="addFormRef" label-width="80px">
          <el-form-item label="所属机构" class="addAdminForm">
            <Rsljigou :propsjigouid="addForm.jigouid" :propsjigouname="addForm.jigouname" @change="changeRsljigouadd"></Rsljigou>
          </el-form-item>
          <el-form-item label="产品名称" class="addAdminForm">
              <el-select v-model="addForm.bomsn" placeholder="请选择产品" class="select2">
                <el-option
                  v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="首次/次次" class="addAdminForm">
            <el-select v-model="addForm.jiagetype" placeholder="请选择" class="select2">
              <el-option label="首次" value="1"></el-option>
              <el-option label="次次" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="最小数量" class="addAdminForm">
            <el-input v-model="addForm.minnum" placeholder="请输入最小数量"></el-input>
          </el-form-item>
          <el-form-item label="最大数量" class="addAdminForm">
            <el-input v-model="addForm.maxnum" placeholder="请输入最大数量"></el-input>
          </el-form-item>
          <el-form-item label="单价" class="addAdminForm">
            <el-input v-model="addForm.money" placeholder="请输入单价"></el-input>
          </el-form-item>
          <el-form-item label="生效时间" class="addAdminForm">
            <el-date-picker v-model="addForm.effectivedate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="funsaveadd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加运营商价格档案 end -->

    </el-tabs>
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  name: 'MyProductMoney',
  data () {
    return {
      keywords: {
        jiagetype: '-1',
        status: '-1',
        bomsn: '',
        jigouid: '-1',
        jigouname: ''
      },
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      optionsproduct: [],
      addForm: {
        jigouid: '0',
        jigouname: '',
        bomsn: '',
        jiagetype: '1',
        minnum: '1',
        maxnum: '99999999',
        money: '',
        effectivedate: ''
      },
      editForm: {
        id: 0,
        jigouid: '0',
        jigouname: '',
        bomsn: '',
        jiagetype: '1',
        minnum: '',
        maxnum: '',
        money: '',
        effectivedate: ''
      },
      editdialog: false,
      SubRule_ProductMoney_ChuNa: false,
      SubRule_ProductMoney_ZongZhang: false,
      SubRule_ProductMoney_ZongJingLi: false
    }
  },
  mounted () {
    this.apiGetWorkprojectList()

    this.addForm.effectivedate = Vue.prototype.FunGetTimeStringLong()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ProductMoney_ChuNa', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ProductMoney_ChuNa = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ProductMoney_ZongZhang', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ProductMoney_ZongZhang = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ProductMoney_ZongJingLi', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ProductMoney_ZongJingLi = true
      }
    })
  },
  methods: {
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetallproductmoneylist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetallproductmoneynum()
      this.apiGetallproductmoneylist()
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    changeRsljigouadd (vid, vname) {
      this.addForm.jigouid = vid
      this.addForm.jigouname = vname
    },
    changeRsljigouedit (vid, vname) {
      this.editForm.jigouid = vid
      this.editForm.jigouname = vname
    },
    clickdelete (index, row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apideleteproductmoney(row.Id)
      })
    },
    funsaveadd () {
      if (!this.addForm.minnum) {
        this.$alert('请输入最小数量', '提示')
        return
      }
      if (!this.addForm.maxnum) {
        this.$alert('请输入最大数量', '提示')
        return
      }
      if (!this.addForm.money) {
        this.$alert('请输入单价', '提示')
        return
      }
      this.apiaddproductmoney()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickedit (index, row) {
      this.editForm.id = row.Id
      this.editForm.bomsn = row.Bomsn
      this.editForm.jigouid = row.Jigouid
      this.editForm.jigouname = row.Jigouname
      this.editForm.jiagetype = row.Jiagetype.toString()
      this.editForm.minnum = row.Minnum
      this.editForm.maxnum = row.Maxnum
      this.editForm.money = row.Money
      this.editForm.effectivedate = row.Effectivedate
      this.editdialog = true
    },
    clickShenHe (status, row) {
      this.$confirm('是否同意该价格档案?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiEditproductmoneyshenhe(status, row.Id)
      })
    },
    funsaveedit () {
      if (!this.editForm.minnum) {
        this.$alert('请输入最小数量', '提示')
        return
      }
      if (!this.editForm.maxnum) {
        this.$alert('请输入最大数量', '提示')
        return
      }
      if (!this.editForm.money) {
        this.$alert('请输入单价', '提示')
        return
      }
      this.apieditproductmoney()
    },
    apiaddproductmoney: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: this.addForm.bomsn,
        jigouid: this.addForm.jigouid,
        jiagetype: this.addForm.jiagetype,
        minnum: this.addForm.minnum,
        maxnum: this.addForm.maxnum,
        money: this.addForm.money,
        effectivedate: this.addForm.effectivedate
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addproductmoney, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetallproductmoneynum()
            that.apiGetallproductmoneylist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        querytype: 1
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.optionsproduct = []
            response.data.List.filter((item1, i1) => {
              if (item1.Bomtype == 1) {
                that.optionsproduct.push({ value: item1.Bomsn, label: item1.Name })
              }
            })
            that.apiGetallproductmoneynum()
            that.apiGetallproductmoneylist()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetallproductmoneylist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        status: that.keywords.status,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid,
        jiagetype: that.keywords.jiagetype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getallproductmoneylist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetallproductmoneynum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        status: that.keywords.status,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid,
        jiagetype: that.keywords.jiagetype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getallproductmoneynum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditproductmoney: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.editForm.id,
        bomsn: this.editForm.bomsn,
        jigouid: this.editForm.jigouid,
        jiagetype: this.editForm.jiagetype,
        minnum: this.editForm.minnum,
        maxnum: this.editForm.maxnum,
        money: this.editForm.money,
        effectivedate: this.editForm.effectivedate
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editproductmoney, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetallproductmoneylist()
          }
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.editdialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apideleteproductmoney: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Deleteproductmoney, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetallproductmoneynum()
            that.apiGetallproductmoneylist()
          }
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditproductmoneyshenhe: function (status, id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productmoneyid: id,
        status: status
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editproductmoneyshenhe, Qs.stringify(data))
        .then(function (response) {
          that.apiGetallproductmoneylist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.el-tree{
  height: 350px;
  overflow-y: scroll
}
.el-tree::-webkit-scrollbar {
    display: none;
}
.select2{
    width: 100%;
}
</style>
